/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { useLocation, useParams } from 'js/lib/useRouter';

import ProductDescriptionPageHeader from 'bundles/composable-page-header-consumer/header-renderers/ProductDescriptionPageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import InteractionGuard from 'bundles/unified-common/components/InteractionGuard';
import { useCoachState } from 'bundles/unified-common/providers/CoachStateProvider';
import { useGlobalCoachChatState } from 'bundles/unified-common/providers/GlobalCoachChatStateProvider';
import { getPageHeaderProps } from 'bundles/unified-description-page-common/utils/getProductHeaderProps';

const ReviewsPageHeaderFooterWrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const params = useParams();

  const { coachOpen } = useCoachState();

  const { isContextProvided, pageChatType } = useGlobalCoachChatState();
  const isFullscreenCoachChatOpen = isContextProvided && coachOpen && pageChatType === null;

  const productSlug: string | undefined = params.productSlug;

  const pageHeaderProps = getPageHeaderProps({ pathname: location.pathname, productSlug });

  return (
    <React.Fragment>
      <ProductDescriptionPageHeader
        getS12nCertificateBannerProps={pageHeaderProps?.getS12nCertificateBannerProps}
        productDiscountPromoBannerProps={pageHeaderProps?.productDiscountPromoBannerProps}
        showSimpleHeader={false}
      />
      <UniversalPageFeatures renderBoostChatOnSsr={false} />

      <InteractionGuard preventInteraction={isFullscreenCoachChatOpen} as="main">
        {children}
      </InteractionGuard>
      <InteractionGuard preventInteraction={isFullscreenCoachChatOpen}>
        <PageFooter isStickyBarPresent />
      </InteractionGuard>
    </React.Fragment>
  );
};

export default ReviewsPageHeaderFooterWrapper;
